module.exports = ".modal-content {\r\n  border: 0px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/component/header-menu/header-menu.component.css
// module id = ./src/app/modules/shared/component/header-menu/header-menu.component.css
// module chunks = main